
import BookIcon from '../../assets/icons/book.svg';
import BookMarkIcon from '../../assets/icons/bookmark.svg';
import CategoriesIcon from '../../assets/icons/categories.svg';
import ThemeIcon from '../../assets/icons/theme.svg';
import NextIcon from '../../assets/icons/next.svg';
import PreviousIcon from '../../assets/icons/previous.svg';
import Circle from '../../assets/icons/circle.svg';
import ShareIcon from '../../assets/icons/share.svg';
import ThinkoChatIcon from '../../assets/icons/thinko-chat.svg';
import SelectIcon from '../../assets/icons/select.svg';
import PodcastIcon from '../../assets/icons/podcast.svg';
import PlayIcon from '../../assets/icons/play.svg';
import ListIcon from '../../assets/icons/list.svg';
import MusicIcon from '../../assets/icons/music.svg';
import PersonalisationIcon from '../../assets/icons/personalisation.svg';
import PauseIcon from '../../assets/icons/pause.svg';
import PolygonIcon from '../../assets/icons/polygon.svg';
import PaginationDotIcon from '../../assets/icons/pagination-dot.svg';
import PaginationDotActiveIcon from '../../assets/icons/pagination-dot-active.svg';
import CloseIcon from '../../assets/icons/close.svg';
import TranslateIcon from '../../assets/icons/translate.svg';
import WatchIcon from '../../assets/icons/watch.svg';
import QueueIcon from '../../assets/icons/queue.svg';
import ThumbsUpIcon from '../../assets/icons/thumbs-up.svg';
import ThumbsDownIcon from '../../assets/icons/thumbs-down.svg';
import ThinkoLogoIcon from '../../assets/icons/thinko-logo.svg';
import LineIcon from '../../assets/icons/line.svg';
import LineIconDark from '../../assets/icons/line_dark.svg';
import FullLogoIcon from '../../assets/icons/thinko-full.svg';
import GoogleLogo from '../../assets/icons/google.svg';
import AppleLogo from '../../assets/icons/apple.svg';
import EllipticalRing from '../../assets/icons/ellipticalRing.svg';
import HourGlass from '../../assets/icons/hourglass.svg';
import News from '../../assets/icons/news.svg';
import Menu from '../../assets/icons/menu.svg';
import Template from '../../assets/icons/template.svg';
import MicrophoneIcon from '../../assets/icons/microphone.svg';
import Backward from '../../assets/icons/backward.svg';
import Forward from '../../assets/icons/forward.svg';
import Template1Web from '../../assets/icons/template1web.svg';
import Template2Web from '../../assets/icons/template2web.svg';
import Template3Web from '../../assets/icons/template3web.svg';
import Template4Web from '../../assets/icons/template4web.svg';
import Template1 from '../../assets/icons/template1.svg';
import Template2 from '../../assets/icons/template2.svg';
import Template3 from '../../assets/icons/template3.svg';
import Template4 from '../../assets/icons/template4.svg';
import Gist from '../../assets/icons/gist.svg';
import FullStory from '../../assets/icons/full_story.svg';
import Twitter from '../../assets/icons/social/twitter.svg';
import Instagram from '../../assets/icons/social/instagram.svg';
import Medium from '../../assets/icons/social/medium.svg';
import Youtube from '../../assets/icons/social/youtube.svg';
import Linkedin from '../../assets/icons/social/linkedin.svg';
import Threads from '../../assets/icons/social/threads.svg';
import Hopeful from '../../assets/icons/sentiment/hopeful.svg';
import Worried from '../../assets/icons/sentiment/worried.svg';
import Supportive from '../../assets/icons/sentiment/supportive.svg';
import Opposed from '../../assets/icons/sentiment/opposed.svg';
import Neutral from '../../assets/icons/sentiment/neutral.svg';
import Uncertain from '../../assets/icons/sentiment/uncertain.svg';
import SwipeDown from '../../assets/icons/swipe_down.svg';
import SwipeUp from '../../assets/icons/swipe_up.svg';
import User from '../../assets/icons/user.svg';
import Submit from '../../assets/icons/submit.svg';
import Collections from '../../assets/icons/collections.svg';
import Phone from '../../assets/icons/phone.svg';
import Up_Arrow from '../../assets/icons/up_arrow.svg'
import Down_Arrow from '../../assets/icons/down_arrow.svg'
import Trending from '../../assets/icons/trending.svg';
import SaveCollection from '../../assets/icons/save_Collection.svg'
import DownSwipeWeb from '../../assets/icons/down_swipe_web.svg';
import UpSwipeWeb from '../../assets/icons/up_swipe_web.svg'
import ShareIconWeb from '../../assets/icons/share_icon.svg'
import Mute from '../../assets/icons/mute.svg'
import Unmute from '../../assets/icons/unmute.svg'
import Eye from '../../assets/icons/eye.svg'

export const Custom_Icons = {
  book: BookIcon,
  bookmark: BookMarkIcon,
  categories: CategoriesIcon,
  list: ListIcon,
  theme: ThemeIcon,
  next: NextIcon,
  previous: PreviousIcon,
  circle: Circle,
  share: ShareIcon,
  'thinko-chat': ThinkoChatIcon,
  select: SelectIcon,
  music: MusicIcon,
  podcast: PodcastIcon,
  play: PlayIcon,
  queue: QueueIcon,
  personalisation: PersonalisationIcon,
  pause: PauseIcon,
  close: CloseIcon,
  translate: TranslateIcon,
  watch: WatchIcon,
  'pagination-dot': PaginationDotIcon,
  'pagination-dot-active': PaginationDotActiveIcon,
  'thumbs-up': ThumbsUpIcon,
  'thumbs-down': ThumbsDownIcon,
  'thinko-logo': ThinkoLogoIcon,
  line: LineIcon,
  'line-dark': LineIconDark,
  'thinko-full': FullLogoIcon,
  google: GoogleLogo,
  apple: AppleLogo,
  "elliptical-ring": EllipticalRing,
  "hour-glass": HourGlass,
  news: News,
  polygon: PolygonIcon,
  menu: Menu,
  template: Template,
  microphone: MicrophoneIcon,
  backward: Backward,
  forward: Forward,
  template1Web: Template1Web,
  template2Web: Template2Web,
  template3Web: Template3Web,
  template4Web: Template4Web,
  template1: Template1,
  template2: Template2,
  template3: Template3,
  template4: Template4,
  gist: Gist,
  'full_story': FullStory,
  twitter: Twitter,
  instagram: Instagram,
  medium: Medium,
  youtube: Youtube,
  linkedin: Linkedin,
  threads: Threads,
  hopeful: Hopeful,
  worried: Worried,
  supportive: Supportive,
  opposed: Opposed,
  neutral: Neutral,
  uncertain: Uncertain,
  swipe_down: SwipeDown,
  swipe_up: SwipeUp,
  user: User,
  submit: Submit,
  collections:Collections,
  phone: Phone,
  up_arrow : Up_Arrow,
  down_arrow : Down_Arrow,
  trending: Trending,
  saveCollection : SaveCollection,
  downSwipeWeb : DownSwipeWeb,
  upSwipeWeb : UpSwipeWeb,
  shareIcon : ShareIconWeb,
  mute :  Mute,
  unmute : Unmute,
  eye : Eye
};